import React from 'react';
import VoucherForm from './VoucherForm'; // Adjust path if needed

const NewVoucherPage = () => {
    // Renders the form in 'create' mode
    return <VoucherForm formType="create" currentVoucherId={null} />;
};

export default NewVoucherPage;